import { api, type ApiResponse } from '../utils';
import type { TourName } from '../tooltips/copy';

export interface ToursSeenResponse {
  tours_seen: Record<string, string>;
}

export interface MarkTourCompleteResponse {
  success: boolean;
  completed_at: string;
}

export const getTours = async (): Promise<ApiResponse<ToursSeenResponse>> => {
  const { data: response } = await api.get('/users/me/tours');
  return response;
};

export const markTourComplete = async (
  name: TourName
): Promise<ApiResponse<MarkTourCompleteResponse>> => {
  const { data: response } = await api.post(
    `/users/me/tours/${name}/complete`
  );
  return response;
};
